
/**
 * Story note management
 * @author Brendan Magee
 * <story-note story="story"></story-note>
 */

import template from './storyNote.html';
import controller from './StoryNote.controller';

function storyNote() {
  return {
    template,
    restrict: 'E',
    scope: {
      story: '='
    },
    controller: 'StoryNoteController',
    link($scope) {
      $scope.noteToEdit = '';
      $scope.noteToEdit = angular.copy($scope.story.note);
    }
  };
}

export default function (ngModule) {
  ngModule.directive('storyNote', storyNote);
  controller(ngModule);
}
